import { first } from 'lodash';
import types from './types';

const initialState = {
  selectedLocations: [],
  selectedPathSuggestion: null,
  pathSuggestions: [],
  createdSegmentId: null,
};

export default function segmentCreation(state = initialState, action) {
  switch (action.type) {
    case types.SELECT_LOCATION:
      return {
        ...state,
        selectedLocations: [...(state.selectedLocations || []), action.payload.id],
        pathSuggestions: null, // clear previous suggestions
        selectedPathSuggestion: null,
      };

    case types.DESELECT_LOCATION:
      return {
        ...state,
        selectedLocations: state.selectedLocations.filter(id => id !== action.payload.id),
        pathSuggestions: null, // clear previous suggestions
        selectedPathSuggestion: null,
      };

    case types.FLIP_SELECTED_LOCATIONS:
      return {
        ...state,
        selectedLocations: [...state.selectedLocations.reverse()],
        pathSuggestions: null, // clear previous suggestions
        selectedPathSuggestion: null,
      };

    case types.SELECT_PATH_SUGGESTION:
      return {
        ...state,
        selectedPathSuggestion: action.payload.pathSuggestion,
      };

    case types.SET_PATH_SUGGESTIONS:
      return {
        ...state,
        pathSuggestions: action.payload.pathSuggestions,
        selectedPathSuggestion: first(action.payload.pathSuggestions),
      };

    case types.SET_CREATED_SEGMENT_ID:
      return {
        ...state,
        createdSegmentId: action.payload.id,
      };

    case types.CLEAR_CREATE_SEGMENT:
      return {
        ...initialState,
      };

    case types.START_CREATE_OPPOSITE_SEGMENT:
      return {
        ...initialState,
        selectedLocations: [...state.selectedLocations.reverse()],
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/ducks/segmentCreation/reducers.js